import React from 'react'
import { branch, renderComponent, compose, withProps } from 'recompose'
import { Redirect } from 'react-router-dom'

import ErrorMessage from '../components/ErrorMessage'

const LoginRedirect = () => <Redirect to="/login" />

const withLoginRedirect = branch(
  ({ data: { error } }) =>
    error.networkError && error.networkError.statusCode === 401,
  renderComponent(LoginRedirect)
)

const withLoginRedirectOrErrorMessage = compose(
  withLoginRedirect,
  withProps(({ data: { error } }) => {
    return {
      message: error.networkError ? 'Network Error' : 'Graphql Error'
    }
  })
)

const withErrorState = compose(
  branch(props => {
    const hasError = props.data.error
    if (hasError) {
      if (props.data.error.message === 'Network error: Failed to fetch') {
        // show no error if network down (use cached data)
        // TODO: how to handle empty data/partial data
        return false
      }
      // console.log('graphql error', JSON.stringify(props.data.error, null, 2))
    }
    return hasError
  }, renderComponent(withLoginRedirectOrErrorMessage(ErrorMessage)))
)

export default withErrorState



// WEBPACK FOOTER //
// ./src/hocs/withErrorState.js